<template>
  <div class="customer-info" v-loading="infoLoading">
    <div class="sec-hd">
      <h2 class="title">基本信息</h2>
      <div class="btn-group" v-if="!(typeof(actionData.customerghkh_editandsave) != 'undefined'&&!actionData.customerghkh_editandsave)">
        <el-button type="primary" size="medium" @click="edit">编辑</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <span class="label">企业ID：</span>
        <div class="value">{{userData.companyid}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">数据来源：</span>
        <div class="value">{{userData.dataFrom}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业名称：</span>
        <div class="value">{{userData.companyname}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">账号注册时间：</span>
        <div class="value">{{userData.ctime}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业类型：</span>
        <div class="value">{{userData.rolecodename }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">所属行业：</span>
        <div class="value">{{userData.industryname }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">用户分类：</span>
        <div class="value">{{userData.companytypename }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">所属大区：</span>
        <div class="value">{{userData.areaCategoryName}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业账号：</span>
        <div class="value">{{userData.account}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">固定电话：</span>
        <div class="value">{{userData.tel}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">联系人：</span>
        <div class="value">{{userData.linkman }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业规模：</span>
        <div class="value">{{userData.scaleName }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">联系方式：</span>
        <div class="value">{{userData.handset}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">注册资本：</span>
        <div class="value">{{userData.buslicenseregisteredcapital}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">联系人职位：</span>
        <div class="value">{{userData.linkManPostName}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业所在地：</span>
        <div class="value">{{userData.companyaddress}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业注册地：</span>
        <div class="value">{{userData.companyregisteraddress}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">经纬度：</span>
        <div class="value">
          <span class="inner-item">经度：{{userData.lng}}</span>
          <span class="inner-item">纬度：{{userData.lat}}</span>
        </div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业法人：</span>
        <div class="value">{{userData.legalperson}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">营业执照编号：</span>
        <div class="value">{{userData.businesslicense}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业执照：</span>
        <div class="value">
          <img v-if="userData.businesslicenseimgpath " :src="userData.businesslicenseimgpath " alt="" class="pic">
        </div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业LOGO：</span>
        <div class="value">
          <img v-if="userData.logo" :src="userData.logo" alt="" class="pic">
        </div>
      </el-col>
      <el-col :span="12">
        <span class="label">关联母公司：</span>
        <div class="value">{{userData.parentCompanyName }}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">企业成立时间：</span>
        <div class="value">{{userData.establishmenttime}}</div>
      </el-col>
      <el-col :span="12">
        <span class="label">年营业额：</span>
        <div class="value">{{userData.yearlyturnover }}万元</div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  // customerAdd,
  customerDetail
} from '@/service/customerInformation.js';
import { 
    getActionData
} from '@/utils/store'
export default {
  data(){
    return{
      actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
      userData:{},


      infoLoading: false,
    }
  },
  mounted () {
    this.pageInit();
  },
  methods: {
    pageInit(){
      this.infoLoading = true
      let custId=Number(this.$route.query.custId);
      customerDetail({
        custId:custId,
      }).then(r=>{
        this.infoLoading = false
        if(r.Result==1){
          let data=r.Data || {};
          if(data.establishmenttime){
            data.establishmenttime=data.establishmenttime.substr(0,10);
          }
          if(data.ctime){
            data.ctime=data.ctime.substr(0,10);
          }
          this.userData={
            ...data
          }
        }else{
          this.userData = {}
        }
      })
    },
    edit(){
      this.$emit('onChange',true);
    }
  },
}
</script>
<style lang="scss">
.customer-info{
	.sec-hd{
		overflow: hidden;
		margin-bottom: 20px;
		.title{
			font-size: 18px;
			color: #333;
			line-height: 40px;
			font-weight: bold;
      float: left;
		}
    .btn-group{
      float: right;
    }
	}
  .el-col{
    overflow: hidden;
    margin-bottom: 10px;
    .label{
      float: left;
      width: 120px;
      font-size: 14px;
      color: #333;
      padding: 5px 10px 5px 0;
      line-height: 24px;
      box-sizing: border-box;
    }
    .value{
      float: left;
      width: calc(100% - 120px);
      font-size: 14px;
      color: #333;
      padding: 5px 10px 5px 0;
      line-height: 24px;
      box-sizing: border-box;
      word-break: break-all;
      >.inner-item{
        display: inline-block;
        white-space: nowrap;
        &+.inner-item{
          margin-left: 10px;
        }
      }
    }
    .pic{
      width: 120px;
      height: 120px;
      background-color: #f8f8f8;
    }
  }
}
</style>